/**
 * 融媒号列表
 */
import React from 'react';
import DragSortTable from "../../../dragSortComponent/DragSortTable";
import moveIcon from "../../../../view/components/storySortModal/image/icon_5@2x.png";

export default class RmSortTable extends DragSortTable {

    getSortColumns = () => {
        const sortColumns = [
            {
                title: "头像",
                dataIndex: "photo",
                key: "photo",
                width: 120,
                ellipsis: true,
                render: (text) => {
                    return(
                        <img style={{width: 46, height: 46, objectFit: "cover", borderRadius: "50%"}} src={text}/>
                    )
                }
            },
            {
                title: "名称",
                dataIndex: "name",
                key: "name",
                width: 320,
                ellipsis: true
            },
            {
                title: "类型",
                dataIndex: "type",
                key: "type",
                width: 160,
            },
            {
                title: "所属单位",
                dataIndex: "deptName",
                key: "deptName",
                width: 160
            },
            {
                title: "操作",
                width: 160,
                render: (text, record) => {
                    return <>
                        <img alt={"拖动排序"} src={moveIcon} style={{width: 20, marginTop: -2, marginRight: 5}}/>
                        <span style={{color: '#0050B3'}}>拖动排序</span>
                    </>
                }
            }
        ];
        this.setState({
            sortColumns
        });
    };

    getSortList() {
        let rmGroupId = this.props.rmGroupId;
        this.request({
            url: "/cm-sites-mmp/rm/all?groupId=" + rmGroupId,
            method: "get",
            callBack: data => {
                let sortList = [];
                if (data && data.length) {
                    sortList = data;
                }
                this.setState({
                    sortList
                })
            }
        });
    }

}